import React from 'react';

import { ComponentProps } from '../utils/types';
import { StyledList } from './styles';
import ListPropsInterface from './types';

const List = React.forwardRef<HTMLUListElement, ListPropsInterface>(
  ({ children, divider = true, lastDivider = false, ...props }, ref) => {
    return (
      <StyledList
        role="list"
        {...props}
        ref={ref}
        divider={divider}
        lastDivider={lastDivider}
      >
        {children}
      </StyledList>
    );
  }
);

export type ListProps = ComponentProps<typeof List>;
export default List;
